"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridNormalPlugin = void 0;
const react_1 = __importDefault(require("react"));
const sizing_1 = require("../../../design/constants/sizing");
const GridDisabledOverlay_1 = require("./components/GridDisabledOverlay/GridDisabledOverlay");
const GridEmptyBody_1 = require("./components/GridEmptyBody/GridEmptyBody");
const GridLoadingOverlay_1 = require("./components/GridLoadingOverlay/GridLoadingOverlay");
const normalGridHeader_1 = require("../../renderers/normalGridHeader");
const normalGridRow_1 = require("../../renderers/normalGridRow");
function gridNormalPlugin(config) {
    const rowSize = sizing_1.sizing.sizeSpaceXL.getIntValue() || 32;
    const subheaderAddons = [];
    const bodyAddons = [];
    const containerAddons = [];
    if (config === null || config === void 0 ? void 0 : config.isEmpty) {
        subheaderAddons.push({
            id: 'empty',
            order: 0,
            render: () => {
                var _a;
                if (config.emptyRenderer) {
                    return config.emptyRenderer();
                }
                return react_1.default.createElement(GridEmptyBody_1.GridEmptyBody, { text: (_a = config.texts) === null || _a === void 0 ? void 0 : _a.empty });
            }
        });
    }
    if (config === null || config === void 0 ? void 0 : config.isLoading) {
        bodyAddons.push({
            id: 'empty',
            order: 0,
            render: () => {
                return react_1.default.createElement(GridLoadingOverlay_1.GridLoadingOverlay, null);
            }
        });
    }
    if (config === null || config === void 0 ? void 0 : config.disabled) {
        containerAddons.push({
            id: 'disabled-overlay',
            order: -9999,
            render: () => react_1.default.createElement(GridDisabledOverlay_1.GridDisabledOverlay, null)
        });
    }
    return () => ({
        headerRenderer: (config === null || config === void 0 ? void 0 : config.headless) ? () => null : (0, normalGridHeader_1.createGridNormalHeaderRenderer)(),
        rowRenderer: (0, normalGridRow_1.createGridNormalRowRenderer)({
            isRowInactive: config === null || config === void 0 ? void 0 : config.isRowInactive,
            isRowDisabled: config === null || config === void 0 ? void 0 : config.isRowDisabled
        }),
        rowHeightGetter: (config === null || config === void 0 ? void 0 : config.rowHeightGetter) || (() => rowSize),
        containerAddons: containerAddons,
        bodyAddons,
        subheaderAddons
    });
}
exports.gridNormalPlugin = gridNormalPlugin;
//# sourceMappingURL=gridNormalPlugin.js.map